module.exports = __webpack_public_path__ + "static/media/ic_video_disable.44ef61ad.svg";